"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileInfo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const profileInfo_style_1 = __importDefault(require("./profileInfo.style"));
class ProfileInfo extends react_1.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children } = this.props;
            return jsx_runtime_1.jsx("div", Object.assign({ className: classes.infoRow }, { children: children }), void 0);
        };
    }
}
exports.ProfileInfo = ProfileInfo;
ProfileInfo.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.any
};
ProfileInfo.defaultProps = {
    children: null
};
exports.default = react_jss_1.default(profileInfo_style_1.default)(ProfileInfo);
//# sourceMappingURL=index.js.map